import React from 'react';
import PropTypes from 'prop-types';

import * as LucidActions from 'common/actions/actions';
import MapboxMapFeatureLayer from 'common/components/mapbox-map-feature-layer';
import MapboxMap from 'common/components/mapbox-map';
import {t} from 'common/utils/translation-util';
import {htmlEscape} from 'common/utils/string-util';

import './index.scss';

export default class Map extends React.Component {
  static propTypes = {
    buildings: PropTypes.array.isRequired,
    disableLink: PropTypes.bool,
    height: PropTypes.number,
    meta: PropTypes.object.isRequired,
    reportId: PropTypes.number,
  };

  static defaultProps = {
    height: 200,
  };

  constructor() {
    super();
    this.state = {
      initialMapBounds: true,
      moved: false,
    };
    this.onMove = this.onMove.bind(this);
    this.saveMapPosition = this.saveMapPosition.bind(this);
  }

  getGeoJSON() {
    return {
      type: 'FeatureCollection',
      features: this.props.buildings
        .filter((building) => building.longitude && building.latitude)
        .map((building) => {
          // GeoJSON marker properties
          return {
            geometry: {
              type: 'Point',
              coordinates: [building.longitude, building.latitude],
            },
            id: building.id,
            properties: {
              address: htmlEscape(building.address),
              icon: {
                className: 'dot',
                // Point of the icon which will correspond to marker's location
                iconAnchor: [10, 26],
                // Size of the icon
                iconSize: [20, 26],
                iconUrl: '/static/svg-store/single-marker.svg',
                // Point from which the popup should open relative to the iconAnchor
                popupAnchor: [0, -26],
              },
              title: htmlEscape(building.displayName),
              url: `/buildings/${building.id}`,
            },
            type: 'Feature',
          };
        }),
    };
  }

  saveMapPosition(event) {
    event.preventDefault();

    const map = this._map.state.mapboxMap;
    const center = map.getCenter();
    const zoom = map.getZoom();
    LucidActions.updateReportConfiguration(this.props.reportId, {
      latitude: center.lat,
      longitude: center.lng,
      zoom,
    });
    this.setState({moved: false});
  }

  render() {
    const meta = this.props.meta;
    const shouldCalculateMapBounds = !meta.longitude;
    return (
      <div className={'MapCard-Map MapCard-Map--visible'}>
        <MapboxMap
          defaultLatitude={meta.latitude}
          defaultLongitude={meta.longitude}
          defaultZoom={meta.zoom}
          height={this.props.height}
          onLoad={() => {}}
          onMove={this.onMove}
          ref={(map) => (this._map = map)}>
          <MapboxMapFeatureLayer
            disableLink={this.props.disableLink}
            featureCollection={this.getGeoJSON()}
            newTab={true}
            onDefaultCoordinates={
              this.state.initialMapBounds && shouldCalculateMapBounds
            }
          />
        </MapboxMap>

        {this.state.moved ? (
          <a
            className={'MapCard-Map-save-state'}
            href={'#'}
            onClick={this.saveMapPosition}>
            {t('Save map position')}
          </a>
        ) : null}
      </div>
    );
  }

  onMove() {
    this.setState({
      initialMapBounds: false,
      moved: true,
    });
  }
}
